import ACTIONS from '../../../store/actions';
import { createLogic } from 'redux-logic';
import currentSelector from '../../selectors/grid';
import getDotProp from '../../../utils/getDotProp';
import { prevPage, nextPage } from '../../actions/grid/page';
import selectItem from '../../actions/grid/select';
var spatialSelectionLogic = createLogic({
  type: [ACTIONS.GRID_SELECTION_SPATIAL],
  process: function process(_ref, dispatch, done) {
    var getState = _ref.getState,
        action = _ref.action;
    var id = action.payload.id;
    var state = getState();
    var selection = state.grid.selection[id] || [];
    var direction = action.payload.e.type;
    var gridData = currentSelector(state, {
      id: id
    });
    var selectedItems = gridData.data.filter(function (i) {
      return i._selected;
    });
    var crtIdx = -1;
    if (selectedItems[0]) crtIdx = gridData.data.indexOf(selectedItems[0]);
    var isVertical = !gridData.view.mode || gridData.view.mode === 'detail';
    var isGrid = gridData.view.mode === 'thumbnail';
    var nextItem = null;

    if (direction === 'down') {
      if (crtIdx === -1) crtIdx = -1;

      if (isVertical) {
        nextItem = gridData.data[crtIdx + 1];
        if (!nextItem) dispatch(nextPage(action.payload.props));
      }
    } else if (direction === 'up') {
      if (crtIdx === -1) crtIdx = gridData.data.length;

      if (isVertical) {
        if (gridData.data[crtIdx - 1]) nextItem = gridData.data[crtIdx - 1];

        if (!nextItem) {
          if (gridData.view.page === 0) {
            if (gridData.data[0]) nextItem = gridData.data[0];
          } else {
            dispatch(prevPage(action.payload.props));
          }
        }
      }
    } else if (direction === 'left') {
      if (isGrid) {
        if (crtIdx === -1) crtIdx = gridData.data.length;
        nextItem = gridData.data[crtIdx - 1];
        if (!nextItem) dispatch(prevPage(action.payload.props));
      } else if (isVertical) {
        dispatch(prevPage(action.payload.props));
      }
    } else if (direction === 'right') {
      if (isGrid) {
        if (crtIdx === -1) crtIdx = -1;
        nextItem = gridData.data[crtIdx + 1];
        if (!nextItem) dispatch(nextPage(action.payload.props));
      } else if (isVertical) {
        dispatch(nextPage(action.payload.props));
      }
    }

    if (nextItem) selection = [getDotProp(nextItem, gridData.view.idKeyProp)];
    dispatch(selectItem('set', action.payload.e, action.payload.props, selection, action.payload.callback));
    done();
  }
});
export default [spatialSelectionLogic];